import React, { useState, useEffect } from 'react';
import './Header.css';
import { AppBar, Box, Link, Typography } from '@mui/material';
import loginLogo from '../common/images/login-logo.png';
import NavBar from './navBar';
import { useUser } from '../../userContext';
import { useSimulator } from '../../simulatorContext';
import DigitalClock from '../common/clock';

const Header = () => {
  const { userName, userLogout, authenticated } = useUser();
  const { simulatorLogout } = useSimulator();
  const [loginDate, setLoginDate] = useState('');
  const [href, setHref] = useState('');
  const [target, setTarget] = useState('');

  useEffect(() => {
    const now = new Date();
    const formatted = now.toLocaleString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  
    setLoginDate(formatted);
  
    const origin = window.location.origin;
    const currPath = window.location.pathname;
    if (currPath === '/' || currPath === '/terms' || currPath === '/eula') {
      setHref('https://phen.ai/');
      setTarget('_blank');
    } else {
      setHref(origin + '/alerts');
      setTarget('_self');
    }

  }, [authenticated]);

  const baseRoute = process.env.REACT_APP_BASE_ROUTE || '/';

  const handleLogout = async() => {
    await simulatorLogout();
    await userLogout();    
  }

  return (
      <AppBar>
        <div className="header-wrapper">
          <div className="header">
            <div className="header-left">
              <span className="logo"> 
                  <Link href={ href }  target={ target } style={{ cursor: 'pointer' }}>
                  <img src={loginLogo} alt= "Login Logo" width='177' height='50'/>
                  </Link>
              </span>
              <span className="header-text">Version 9.25</span>
            </div>

            { userName !== null && 
              <div className="header-right">
                <div className="top-row">
                  <span className="status-text">Logged in as {userName} | </span>
                  <Link href={baseRoute} onClick={handleLogout} style={{ cursor: 'pointer' }} underline="hover" color="#c1d4e7">Logout</Link>
                </div> 
                <div className="bottom-row">
                  <span className="updated-text"> 
                  <Typography sx={{fontFamily:'sans-serif', fontSize: '0.98rem'}}> {loginDate}  <DigitalClock />  </Typography>
                  </span>
                </div>
              </div>
            }
          </div>
              { authenticated && 
                  <Box sx={{ mt: 8 }}>                    
                      <NavBar /> 
                  </Box>
              }
        </div>        
      </AppBar>
  );
};

export default Header;
